import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  forwardRef,
} from 'react';
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import styles from 'styles/Unit.module.scss';
import html2canvas from 'html2canvas';
import { useTest, useUnit } from 'hooks/units';

import {
  fetchTestAsync,
  fetchUnitAsync,
  getIsUnitLoading,
  getUnit,
} from 'store/units/index';
import { convertFileJPG, parseHtml } from 'helpers';
import { SECURITY_TYPE, UNIT_STATUS } from 'constants/constants';
import fileApi from 'api/fileApi';

import ContentResult from './ContentResult/ContentResult';
import ContentStart from '../ContentStart';
import StartTest from './StartTest/StartTest';
import ContentQuestion from './ContentQuestion/ContentQuestion';
import unitCourseApi from '../../../../../api/unitCourseApi';
import { getThemeColor } from 'store/settings';
import { shuffleArrayWithValue } from 'helpers/number';
import { isMobile } from 'react-device-detect';
import { useRouter } from 'next/router';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { FaRegQuestionCircle } from 'react-icons/fa';
import styled from '@emotion/styled';
import AntdTab from 'components/Tab/antd-tab';

const Stylescal = styled.div`
  & > div p img {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
  }
`;

const ContentTest = forwardRef((props, ref) => {
  const { quizState, displayRight } = props;

  const {
    toggleBookmark,
    bookmarked,
    setBookmarked,
    quizPosition,
    setQuizPosition,
    availablePosition,
    setAvailablePosition,
    startQuestionIndex,
    setStartQuestionIndex,
    setDurationDisable,
    durationDisable,
    iconDisplay,
    setIsLoading,
    isLoading,
    setIsSync,
    isSync,
  } = quizState;

  const dispatch = useDispatch();
  const [active, setActive] = useState('questions');
  const getUnitLoading = useSelector(getIsUnitLoading);

  const unitSelected = useUnit();
  const { query } = useRouter();
  const test = useTest();
  const [timer, setTimer] = useState();
  const valueRef = useRef();
  const themeStatus = useSelector(getThemeColor);
  const config = unitSelected?.config;
  // const [availablePosition, setAvailablePosition] = useState([]);
  const [description, setDescription] = useState(false);
  // const [quizPosition, setQuizPosition] = useState([]);
  // const [startQuestionIndex, setStartQuestionIndex] = useState();
  const isShuffle = config?.randomization?.questions;

  async function trackUserCourseUnit() {
    const result = await unitCourseApi.trackUserCourseTest(unitSelected._id, 5);
    // checkStartTest();
  }

  useLayoutEffect(() => {
    if (test?.status === 'COMPLETED' || test?.status === 'FAILED') {
      sessionStorage.removeItem('shuffledArrayQuiz');
      setAvailablePosition([]);
    }
  }, []);

  useEffect(() => {
    if (!test?.unitQuestion && unitSelected?._id === query?.unitId) {
      shufflingTest();
    }
  }, [unitSelected]);

  useEffect(() => {
    const availablePositionArrayString =
      sessionStorage.getItem('shuffledArrayQuiz');
    if (availablePositionArrayString) {
      const availablePositionArray = JSON.parse(availablePositionArrayString);
      setQuizPosition(availablePositionArray);
    }
  }, []);

  const shufflingTest = () => {
    if (
      unitSelected?.userNotAttemptedQuestions?.length &&
      !availablePosition?.length
    ) {
      let notAttendedShuffled = isShuffle
        ? shuffleArrayWithValue(unitSelected?.userNotAttemptedQuestions)
        : unitSelected?.userNotAttemptedQuestions;

      let attendedShuffled = isShuffle
        ? shuffleArrayWithValue(unitSelected?.userAttemptedQuestions)
        : unitSelected?.userAttemptedQuestions;

      let mergeShuffled = [...attendedShuffled, ...notAttendedShuffled];

      if (unitSelected?.shuffleOrder?.length) {
        mergeShuffled = unitSelected?.shuffleOrder;
      }

      sessionStorage.setItem(
        'shuffledArrayQuiz',
        JSON.stringify(mergeShuffled),
      );
      setStartQuestionIndex(mergeShuffled[0]);
      setAvailablePosition(mergeShuffled);
      return;
    }

    let shuffledArray = sessionStorage.getItem('shuffledArrayQuiz')
      ? JSON.parse(sessionStorage.getItem('shuffledArrayQuiz')) || []
      : [];

    // if (
    //   sessionStorage.getItem('shuffledArrayQuiz') !== null &&
    //   sessionStorage.getItem('shuffledArrayQuiz') !== '' &&
    //   sessionStorage.getItem('shuffledArrayQuiz') !== undefined &&
    //   shuffledArray?.length == unitSelected?.totalQuesiton
    // ) {
    //   setStartQuestionIndex(
    //     JSON.parse(sessionStorage.getItem('shuffledArrayQuiz'))[0],
    //   );
    //   setAvailablePosition(
    //     JSON.parse(sessionStorage.getItem('shuffledArrayQuiz')),
    //   );
    // } else

    if (unitSelected?.totalQuesiton) {
      let shuffledArray2 = isShuffle
        ? shuffleArrayWithValue(
            unitSelected?.reAttempt
              ? unitSelected?.failedQuestions
              : unitSelected?.totalQuesiton || 0,
          )
        : unitSelected?.reAttempt
        ? unitSelected?.failedQuestions
        : Array.from(
            Array(parseInt(unitSelected?.totalQuesiton || 0)),
            (_, index) => index + 1,
          );

      if (unitSelected?.shuffleOrder?.length) {
        shuffledArray2 = unitSelected?.shuffleOrder;
      }

      sessionStorage.setItem(
        'shuffledArrayQuiz',
        JSON.stringify(shuffledArray2),
      );

      setStartQuestionIndex(shuffledArray2[0]);
      setAvailablePosition(shuffledArray2);

      return;

      let shuffledArray = isShuffle
        ? shuffleArrayWithValue(
            unitSelected?.reAttempt
              ? unitSelected?.totalFaiedQuestions
              : unitSelected?.totalQuesiton || 0,
          )
        : Array.from(
            Array(
              parseInt(
                unitSelected?.reAttempt
                  ? unitSelected?.totalFaiedQuestions
                  : unitSelected?.totalQuesiton || 0,
              ),
            ),
            (_, index) => index + 1,
          );
      sessionStorage.setItem(
        'shuffledArrayQuiz',
        JSON.stringify(shuffledArray),
      );
      setStartQuestionIndex(shuffledArray[0]);
      setAvailablePosition(shuffledArray);
    }
  };

  const captureScreenshot = () => {
    if (!test?.unitQuestion) return;
    const target = document.getElementById('screenshot-area');

    if (!target) {
      console.warn('Target element not found!');
      return;
    }

    html2canvas(document.body).then((canvas) => {
      canvas.toBlob(async (blob) => {
        if (blob) {
          const file = new File([blob], `SnapShot_${Date.now()}.jpg`, {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });

          console.log(file);

          const formData = new FormData();

          formData.append('users-file', convertFileJPG(blob));
          formData.append('unit', unitSelected?._id);
          let config = { unit: unitSelected?._id };
          const fileUploaded = await fileApi.uploadUserFile(formData, config);
        }
      }, 'image/jpeg');
    });
  };

  // const captureScreenshot = async () => {
  //   if (!test?.unitQuestion) return;

  //   try {
  //     // Ask user to share screen
  //     const stream = await navigator.mediaDevices.getDisplayMedia({
  //       video: true,
  //     });

  //     const track = stream.getVideoTracks()[0];
  //     const imageCapture = new ImageCapture(track);
  //     const bitmap = await imageCapture.grabFrame();

  //     // Draw the frame on a canvas
  //     const canvas = document.createElement('canvas');
  //     canvas.width = bitmap.width;
  //     canvas.height = bitmap.height;
  //     const ctx = canvas.getContext('2d');
  //     ctx.drawImage(bitmap, 0, 0);

  //     // Convert to blob and upload
  //     canvas.toBlob(async (blob) => {
  //       if (!blob) return;

  //       const file = new File([blob], `SnapShot_${Date.now()}.jpg`, {
  //         type: 'image/jpeg',
  //         lastModified: Date.now(),
  //       });

  //       console.log('📸 Screenshot File:', file);

  //       const formData = new FormData();
  //       formData.append('users-file', convertFileJPG(blob));
  //       formData.append('unit', unitSelected?._id);

  //       try {
  //         const fileUploaded = await fileApi.uploadUserFile(formData);
  //         console.log('✅ Upload Success:', fileUploaded);
  //       } catch (err) {
  //         console.error('❌ Upload Error:', err);
  //       }

  //       track.stop(); // Important: stop sharing screen
  //     }, 'image/jpeg');
  //   } catch (err) {
  //     console.error('❌ Screen capture failed:', err);
  //   }
  // };

  useEffect(() => {
    if (!test?.unitQuestion) return;

    const interval = setInterval(() => {
      captureScreenshot();
    }, 10000);

    return () => clearInterval(interval);
  }, [unitSelected, test]);

  useEffect(() => {
    if (isMobile) {
      document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  useEffect(() => {
    valueRef.current = timer;
  }, [timer]);
  useEffect(() => {
    return () => {
      for (var i = 0; i < 1000; i++) {
        window.clearInterval(i);
      }
    };
  }, []);

  const handleStartTest = async () => {
    try {
      let interval = setInterval(trackUserCourseUnit, 5000);
      setTimer(interval);

      if (unitSelected) {
        setBookmarked(unitSelected?.bookMark);
      }

      if (config?.security) {
        if (config?.security === SECURITY_TYPE.PASSWORD) {
          const passwordElm = document.getElementById('password');
          const value = passwordElm.value;
          await dispatch(
            fetchTestAsync(
              {
                id: unitSelected?._id,
                questionIndex: startQuestionIndex,
                ...(isShuffle &&
                  (unitSelected?.status == 'RESET' ||
                    unitSelected?.status == 'RESUBMIT' ||
                    unitSelected?.reAttempt) && { shuffle: true }),

                ...(unitSelected?.reAttempt && {
                  shuffle: true,
                }),
              },
              {
                password: value,
                ...(availablePosition?.length && {
                  shuffleOrder: availablePosition?.length
                    ? availablePosition
                    : [],
                }),
                ...(!unitSelected?.testStartTime && {
                  testStartTime: new Date(),
                }),
              },
            ),
          );
        } else {
          const canvasElm = document.getElementById('canvas');
          canvasElm.toBlob(async function (blob) {
            const formData = new FormData();
            formData.append('users-file', convertFileJPG(blob));

            const fileUploaded = await fileApi.uploadUserFile(formData);

            await dispatch(
              fetchTestAsync(
                {
                  id: unitSelected?._id,
                  questionIndex: startQuestionIndex,
                  ...(isShuffle &&
                    (unitSelected?.status == 'RESET' ||
                      unitSelected?.status == 'RESUBMIT' ||
                      unitSelected?.reAttempt) && {
                      shuffle: true,
                    }),
                  ...(unitSelected?.reAttempt && {
                    shuffle: true,
                  }),
                },
                {
                  id: fileUploaded?._id,
                  ...(availablePosition?.length && {
                    shuffleOrder: availablePosition?.length
                      ? availablePosition
                      : [],
                  }),
                  ...(!unitSelected?.testStartTime && {
                    testStartTime: new Date(),
                  }),
                },
              ),
            );

            await dispatch(fetchUnitAsync(query?.unitId));
          }, 'image/jpeg');
        }
      } else {
        await dispatch(
          fetchTestAsync(
            {
              id: unitSelected?._id,
              questionIndex: startQuestionIndex,
              ...(isShuffle &&
                (unitSelected?.status == 'RESET' ||
                  unitSelected?.status == 'RESUBMIT' ||
                  unitSelected?.reAttempt) && {
                  shuffle: true,
                }),
              ...(unitSelected?.reAttempt && {
                shuffle: true,
              }),
            },
            {
              ...(availablePosition?.length && {
                shuffleOrder: availablePosition?.length
                  ? availablePosition
                  : [],
              }),
              ...(!unitSelected?.testStartTime && {
                testStartTime: new Date(),
              }),
            },
          ),
        );
      }
      if (iconDisplay) {
        displayRight();
      }

      if (config?.security !== SECURITY_TYPE.SNAPSHOT) {
        await dispatch(fetchUnitAsync(query?.unitId));
      }
    } catch (e) {
      throw e;
    }
  };

  useEffect(() => {
    if (unitSelected?.isCompleted) {
      localStorage.removeItem('unitId');
      localStorage.removeItem('testStartTime');
      sessionStorage.removeItem('testSeconds');
      sessionStorage.removeItem('shuffledArrayQuiz');
      setAvailablePosition([]);
    }
  }, [unitSelected]);

  const currentTest =
    (unitSelected?.userAttemptedQuestions?.length ===
      unitSelected?.totalQuesiton ||
      unitSelected?.results?.length === unitSelected?.totalQuesiton ||
      unitSelected?.isDurationEnd) &&
    unitSelected?.isCompleted;
  if (
    unitSelected?.status === UNIT_STATUS.FAILED ||
    unitSelected?.status === UNIT_STATUS.COMPLETED ||
    unitSelected?.isCompleted ||
    (unitSelected?.oldStatus
      ? unitSelected?.status === UNIT_STATUS.PENDING
      : false)
  ) {
    return <ContentResult />;
  }

  return (
    <LoadingOverlay
      active={getUnitLoading}
      spinner
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgb(187 181 181 / 50%)',
        }),
      }}
    >
      {/* <div>
        <button className="border-0" onClick={handleclick}>
          <IoInformationCircleOutline size={20} />
        </button>
        <div>
          {description && config.message && (
            <p
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: config?.message }}
            />
          )}
        </div>
      </div> */}
      <Card style={{ zIndex: 1, marginTop: '3%' }}>
        <CardBody>
          {!test?.question && !test?.isLoading && (
            <ContentStart
              setIntervalId={timer}
              content={`Test contains ${
                unitSelected?.reAttempt
                  ? unitSelected?.totalFaiedQuestions
                  : unitSelected?.totalQuesiton || 0
              } question(s).`}
              componentBtnStart={<StartTest onStartTest={handleStartTest} />}
            />
          )}
          {test?.isLoading && (
            <div className="d-flex justify-content-center">
              <Spinner style={{ color: `${themeStatus}` }} />
            </div>
          )}
          {test?.question && (
            <AntdTab activeKey={active} onChange={setActive}>
              {({ TabPane }) => (
                <>
                  <TabPane
                    tab={
                      <span className="d-flex align-items-center">
                        <IoInformationCircleOutline
                          size={20}
                          className="mr-05"
                        />
                        Instructions
                      </span>
                    }
                    key="instructions"
                    disabled={!config?.message}
                  >
                    <Stylescal>{parseHtml(config?.message)}</Stylescal>
                  </TabPane>
                  <TabPane
                    tab={
                      <span className="d-flex align-items-center">
                        <FaRegQuestionCircle size={20} className="mr-05" />
                        Questions
                      </span>
                    }
                    key="questions"
                  >
                    <ContentQuestion
                      ref={ref}
                      setIntervalId={timer}
                      availablePosition={availablePosition}
                      isShuffle={isShuffle}
                      availablePositionArray={quizPosition || []}
                      toggleBookmark={toggleBookmark}
                      setBookmarked={setBookmarked}
                      bookmarked={bookmarked}
                      durationDisable={durationDisable}
                      setDurationDisable={setDurationDisable}
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      setIsSync={setIsSync}
                      isSync={isSync}
                    />
                  </TabPane>
                </>
              )}
            </AntdTab>
          )}
        </CardBody>
      </Card>
    </LoadingOverlay>
  );
});

export default ContentTest;
